import React, { ReactElement, useCallback } from "react";
import styles from "./AccordionItem.module.scss";

import clsx from "clsx";
import { Icon } from "../Icon/Icon";
import { BackgroundColor, classForBackground } from "../Backgrounds/background";

export type AccordionItemProps = {
  id: string;
  trackingName: string;
  title: string | ReactElement;
  backgroundColor?: BackgroundColor;
  isExpanded?: boolean;
  onToggleExpanedItem?: (key: string | undefined) => void;
};

export const AccordionItem: React.FC<
  React.PropsWithChildren<AccordionItemProps>
> = ({
  title,
  id,
  isExpanded = false,
  onToggleExpanedItem,
  backgroundColor,
  trackingName,
  children
}) => {
  const controlId = `accordion-control-${id}`;
  const contentId = `accordion-content-${id}`;

  const _onToggleExpanedItem = useCallback(() => {
    if (onToggleExpanedItem) onToggleExpanedItem(id);
  }, [id, onToggleExpanedItem]);

  const bgClass = classForBackground(backgroundColor);

  return (
    <div
      className={clsx(styles.item, bgClass)}
      data-content-name={`accordion-${trackingName}`}
    >
      <button
        className={styles.header}
        onClick={_onToggleExpanedItem}
        data-content-piece={isExpanded ? "collapse" : "expand"}
        aria-expanded={isExpanded}
        aria-controls={contentId}
        id={controlId}
      >
        <h3 className={styles.title}>{title}</h3>
        <div>
          <Icon
            name={isExpanded ? "chevron-up" : "chevron-down"}
            size="1.5x"
            padding="inline"
          />
        </div>
      </button>

      {isExpanded && (
        <div
          id={contentId}
          role="region"
          aria-labelledby={controlId}
          className={styles.content}
        >
          {children}
        </div>
      )}
    </div>
  );
};
